import Phaser from 'phaser';
import { DESIGN } from '@/config';
import { BootScene } from '@/scenes/BootScene';
import { PreloadScene } from '@/scenes/PreloadScene';
import { MainMenuScene } from '@/scenes/MainMenuScene';
import { WorldMapScene } from '@/scenes/WorldMapScene';
import { BattleScene } from '@/scenes/BattleScene';
import { HUDScene } from '@/scenes/HUDScene';

// vite-plugin-pwa auto-injects the service-worker registration at build time
// (injectRegister: 'auto'), so the game installs & runs offline with no code here.

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#1b1e30',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: DESIGN.width,
    height: DESIGN.height,
  },
  render: { antialias: true, roundPixels: false },
  input: { activePointers: 3 }, // support two-finger pinch + a tap
  scene: [BootScene, PreloadScene, MainMenuScene, WorldMapScene, BattleScene, HUDScene],
});

// Temporary dev hook for on-device/headless debugging; remove before release.
if ((import.meta as { env?: { DEV?: boolean } }).env?.DEV) {
  (window as unknown as { game: Phaser.Game }).game = game;
}
